var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var CfsmBase = require('./cfsmBase');

var _require = require('./enum'),
    digits = _require.digits,
    ops = _require.ops,
    END = _require.END;

var opsSet = new Set(Object.values(ops));

function getLastOp(expression) {
  for (var i = expression.length - 1; i >= 0; i--) {
    if (opsSet.has(expression[i])) {
      return {
        op: expression[i],
        opIndex: i
      };
    }
  }

  return {};
}

function intArrayToFloat(a) {
  return parseFloat(a.join(''));
}

function _calculate(expression) {
  var _getLastOp = getLastOp(expression),
      op = _getLastOp.op,
      opIndex = _getLastOp.opIndex;

  if (!opIndex) {
    return intArrayToFloat(expression);
  }

  var right = intArrayToFloat(expression.slice(opIndex + 1));

  var left = _calculate(expression.slice(0, opIndex));

  switch (op) {
    case ops.ADD:
      return left + right;

    case ops.SUBTRACT:
      return left - right;

    case ops.MULTIPLY:
      return left * right;

    case ops.DIVIDE:
      return left / right;

    default:
      throw new Error("Unsupported operator '".concat(op, "'."));
  }
}

var Cfsm =
/*#__PURE__*/
function (_CfsmBase) {
  "use strict";

  _inherits(Cfsm, _CfsmBase);

  function Cfsm() {
    _classCallCheck(this, Cfsm);

    return _possibleConstructorReturn(this, _getPrototypeOf(Cfsm).apply(this, arguments));
  }

  _createClass(Cfsm, [{
    key: "calculate",
    value: function calculate() {
      _get(_getPrototypeOf(Cfsm.prototype), "end", this).call(this);

      var expression = this.history.slice(0, -1);
      return _calculate(expression);
    }
  }, {
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(Cfsm.prototype), "clearHistory", this).call(this);

      _get(_getPrototypeOf(Cfsm.prototype), "reset", this).call(this);
    }
  }], [{
    key: "digits",
    get: function get() {
      return digits;
    }
  }, {
    key: "ops",
    get: function get() {
      return ops;
    }
  }]);

  return Cfsm;
}(CfsmBase);

module.exports = Cfsm;